import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

:root{
    --backgroundColorHover: #f3f3f3;
    --textBlack: rgba(0,0,0,.84);
}

*{
    margin:0;
    padding:0;
    outline:0;
    box-sizing:border-box;
}

html , body , #root{
    height:100%;
    overflow:${window.screen.width < 800? 'unset':'hidden'};
}

body {
  background: #f0f2f5;
  font: 14px Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased !important;
  font-family: 'Ubuntu', sans-serif!important;
  letter-spacing: .5px!important;
  color: #333333!important;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing:antialiased;
  ::-webkit-scrollbar {
       margin-right:10px;
        width:5px!important;
        @media(max-width: 900px){
            width:1px!important;
        }
    };
    a{
       text-decoration:inherit;
       color:inherit;
       cursor:pointer;
    }
}
button{
    font: 14px Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased !important;
    font-family: 'Ubuntu', sans-serif;
    letter-spacing: .5px!important;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing:antialiased;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f7f7f7;
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #828282;
}

.backgorundHoverOptions:hover {
    background-color: #f3f3f3;
    transition-duration: .3s
}

.customeTheme {
    color: var(--textBlack);
    background-color: #fff !important;
    opacity:1!important;
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.75);
}


.tremerDiv {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.5s;

  /* When the animation is finished, start again */
  animation-iteration-count: 1;
}

@keyframes shake {
  0% { transform: translate(1px, 1px);}
  10% { transform: translate(-1px, -2px);}
  20% { transform: translate(-3px, 0px);}
  30% { transform: translate(3px, 2px);}
  40% { transform: translate(1px, -1px);}
  50% { transform: translate(-1px, 2px);}
  60% { transform: translate(-3px, 1px);}
  70% { transform: translate(3px, 1px);}
  80% { transform: translate(-1px, -1px);}
  90% { transform: translate(1px, 2px);}
  100% { transform: translate(1px, -2px);}
}

.vermelho {
    background-color: #ff7171;
    color: #fff;

    :hover{
        background-color: #ff3a3a;
    }
}
.azul {
    background-color: #71a1ff;
    color: #fff;

    :hover{
        background-color: #2871ff;
    }
}
`;
